import { render, staticRenderFns } from "./ConnectContacts.vue?vue&type=template&id=3d54c766&scoped=true&"
import script from "./ConnectContacts.vue?vue&type=script&lang=js&"
export * from "./ConnectContacts.vue?vue&type=script&lang=js&"
import style0 from "./ConnectContacts.vue?vue&type=style&index=0&id=3d54c766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54c766",
  null
  
)

export default component.exports